export const validBankAcctRegex = /^[a-zA-Z0-9\s]*$/;

export const validSwiftCodeRegex = /^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/;

export const validateZipRegex = /^\d{5}-\d{4}$|^\d{5}$/;

export const validSSNRegex = /^.{3}-.{2}-.{4}$/;

export const validTAXID = /^[0-9a-zA-Z-]+$/;

export const validPhoneNumber = /^(?=.{7,17}$)[+]{0,1}[0-9() .-]{1,}$/;
